module.exports = __webpack_public_path__ + "img/logo.05e9de0a.png";